import { SpinResponse } from '@cgs/data-access';
import {
  AbstractSpinConfig,
  GameStateMachine,
  PlaySoundAction,
  ReelsEngine,
  ReelsSoundModel,
  SpinAction,
  WaitForAction,
} from '@cgs/machines';
import { EmptyAction, IntervalAction, SequenceAction } from '@cgs/wge';

export class CorsicaSpinAction extends SpinAction {
  constructor(
    engine: ReelsEngine,
    gameStateMachine: GameStateMachine<SpinResponse>,
    regularSpinConfig: AbstractSpinConfig,
    freeSpinConfig: AbstractSpinConfig,
    sounds: ReelsSoundModel,
    useSounds: boolean,
    private readonly spinDelayFactor: number
  ) {
    super(engine, gameStateMachine, regularSpinConfig, freeSpinConfig, sounds, useSounds);
  }

  public playSpinSound(): void {
    this._sounds.startSpinSound.GoToState('stop_sound');
    this._sounds.startSpinSound.GoToState('sound');
  }

  buildAction(): IntervalAction {
    const actions: IntervalAction[] = [];
    if (this.useSounds) {
      actions.push(new PlaySoundAction(() => this.playSpinSound()));
    }

    for (let reel = 0; reel < this.engine.ReelConfig.reelCount; ++reel) {
      if (reel > 0 && this.spinDelayFactor > 0) {
        // Don't delay first reel
        actions.push(
          new EmptyAction().withDuration(this.getSpinConfig().spinStartDelay * this.spinDelayFactor)
        );
      }
      actions.push(this.spin(reel));
    }
    actions.push(new WaitForAction(this.engine.slotsAccelerated));
    const result = new SequenceAction(actions);

    return result;
  }
}
